<template>
  <div class="textbox-form">
    <color-picker label="Font Color" :value="color" @pick="updateField('color', $event)" :lastUsedColors="lastUsedColors" @updateLastUsedColors="updateLastUsedColors"/>
    <color-picker label="Background Color" :value="bgColor" @pick="updateField('bgColor', $event)" :lastUsedColors="lastUsedColors" @updateLastUsedColors="updateLastUsedColors"/>
    <label for="textbox-content">TEXTBOX CONTENT<lang-toggler :lang="markdown.lang" @input="markdown.lang = $event" @applyAll="onApplyToAllLangs($event)"/></label>
    <!-- <textarea type="textarea" id="textbox-content" class="textbox-content" v-model="markdown[markdown.lang]" v-on:blur="updateLangField('markdown', markdown.lang, $event)" /> -->
     <markdown-editor :configs="configs" name="text" :highlight="false" v-validate="'required'" v-model="markdown[markdown.lang]" @blur="updateLangField('markdown', markdown.lang, $event)" ref="markdownEditor"></markdown-editor>
     <span class="invalid">{{ errors.first('text') }}</span>
      <!--
      <div class="button is-primary" v-on:click="translate(language)">Translate</div>
      -->
    <!-- moved outside to the generic form
    <label for="content-alignement">Text Align</label>
    <align-picker name="content-alignement" v-on:pick="updateField('textAlignement', $event)" :value="textAlignement" :options="['t-left', 't-center', 't-right', 't-justify']" />
    
    <label for="content-alignement">Text vertical Align</label>
    <align-picker name="content-alignement" v-on:pick="updateField('textVerticalAlignement', $event)" :value="textVerticalAlignement" :options="['v-top', 'v-center', 'v-bottom']" />
    
    <label for="content-scaling">Text Scaling</label>
    -->
  </div>
</template>

<script>
import { mapState, mapMutations } from 'vuex'
import ColorPicker from '../core/colorPicker'
import AlignPicker from './alignPicker'
import Tab from '../core/Tab'
import Tabs from '../core/Tabs'
import LangToggler from './langToggler'
import { multiLangTextObject } from './../../utils/multiLang'
import MarkdownEditor from 'vue-simplemde/src/markdown-editor'

export default {
  name: 'textbox-form',

  components: {
    ColorPicker,
    AlignPicker,
    Tab,
    Tabs,
    LangToggler,
    MarkdownEditor
  },

  props: {
    modelItem: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },

  data() {
    return {
      color: null,
      bgColor: null,
      markdown: null,
      textAlignement: null,
      textVerticalAlignement: null,
      configs: {
        toolbar: ['bold', 'italic', 'heading', '|', 'quote', 'unordered-list', 'ordered-list'],
        spellChecker: false,
      }
    }
  },

  computed: {
    ...mapState(['lastUsedColors']),
  },

  watch: {
    'modelItem': 'init'
  },

  created() {
    this.init()
  },

  methods: {
  ...mapMutations(['updateLastUsedColors']),

    init: function () {
      let value = this.modelItem.value
      this.color = value.color
      this.bgColor = value.bgColor
      this.markdown = multiLangTextObject(value.markdown)
      this.textAlignement = value.textAlignement
      this.textVerticalAlignement = value.textVerticalAlignement
    },

    updateField: function (field, eventOrValue) {
      this[field] = eventOrValue.target
        ? eventOrValue.target.value
        : eventOrValue
      this.emit()
    },

    updateLangField: function (field, lang, eventOrValue) {
      this[field][lang] = eventOrValue.target ? eventOrValue.target.value : eventOrValue
      this.emit()
    },

    emit: function () {
      const { color, bgColor, markdown, textAlignement, textVerticalAlignement } = this

      this.modelItem.value = {
        color,
        bgColor,
        markdown,
        textAlignement,
        textVerticalAlignement,
        languages: this.modelItem.value.languages
      }

      this.$emit("pick", this.modelItem.value)
    },

    onApplyToAllLangs: function (ev) {
      let textVal = this.markdown[ev]

      for (const k in this.markdown) {
        if (k !== 'lang') {
          this.markdown[k] = textVal
        }
      }
    }
  }
}
</script>